import { initializeApp, getApps } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyDkP4qjJ0f0spVo0o6OgQDc_1CusbWIZSc",
  authDomain: "gabmic-ai.firebaseapp.com",
  databaseURL: "https://gabmic-ai-default-rtdb.firebaseio.com",
  projectId: "gabmic-ai",
  storageBucket: "gabmic-ai.firebasestorage.app",
  messagingSenderId: "899888503661",
  appId: "1:899888503661:web:66efbf6c9176e7b5e29864",
  measurementId: "G-07MNSLQNFF"
};

const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
const auth = getAuth(app);
const db = getFirestore(app);
const functions = getFunctions(app, 'us-central1');
const storage = getStorage(app);

export { auth, db, functions, storage };
